"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Download = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Download = function Download() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.99996 17.3354C9.82318 17.3354 9.65427 17.2622 9.53329 17.1333L1.81329 9.41333C1.68708 9.28816 1.61609 9.11776 1.61609 8.94C1.61609 8.76224 1.68708 8.59184 1.81329 8.46667L2.07996 8.2C2.20539 8.06979 2.37918 7.99738 2.55996 8H5.99996V0.666667C5.99996 0.298477 6.29844 0 6.66663 0H13.3333C13.7015 0 14 0.298477 14 0.666667V8H17.44C17.6207 7.99738 17.7945 8.06979 17.92 8.2L18.1866 8.46667C18.3128 8.59184 18.3838 8.76224 18.3838 8.94C18.3838 9.11776 18.3128 9.28816 18.1866 9.41333L10.4666 17.1333C10.3456 17.2622 10.1767 17.3354 9.99996 17.3354ZM19.3333 22V20.6667C19.3333 20.2985 19.0348 20 18.6666 20H1.33329C0.965103 20 0.666626 20.2985 0.666626 20.6667V22C0.666626 22.3682 0.965103 22.6667 1.33329 22.6667H18.6666C19.0348 22.6667 19.3333 22.3682 19.3333 22Z",
    clipRule: "evenodd"
  });
};

exports.Download = Download;